import { createFileRoute } from "@tanstack/react-router";
import { TestimonialFeatureSectionTwo } from "@/components/sections/TestimonialFeatureSectionTwo";

export const Route = createFileRoute("/testimonial-archive")({
  head: () => ({
    meta: [
      { title: "Testimonial Archive — Mind Media" },
      {
        name: "description",
        content: "Internal archive of stored client testimonial sections kept for future use.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Testimonial Archive — Mind Media" },
      {
        property: "og:description",
        content: "Internal archive of stored client testimonial sections kept for future use.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: TestimonialArchivePage,
});

function TestimonialArchivePage() {
  return (
    <main className="min-h-screen bg-background">
      <div className="mx-auto max-w-7xl px-6 pt-16">
        <h1 className="text-2xl font-semibold text-foreground">Testimonial Archive</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Stored for future use. This page is not indexed.
        </p>
      </div>
      <TestimonialFeatureSectionTwo />
    </main>
  );
}
